import { createSelector } from 'reselect'

import { lookupInAPI } from '../api/selectors'

export const lookupInActives = (state, model, lookup) => {
  const modelLookup = state && state.actives && state.actives[model]
  if (!lookup) return modelLookup

  return modelLookup && state.actives[model][lookup]
}

export function makeGetActiveSelector(
  model,
  lookup,
  getRecord,
  sortFunc,
  returnFirst,
) {
  const lookupSelector = (state) => lookupInActives(state, model, lookup)
  const recordsSelector = (state) => lookupInAPI(model, state)

  return createSelector(
    [lookupSelector, recordsSelector, (_, props) => props.id],
    (lookup, records, id) => {
      const activeIds = lookup?.[id]
      if (!activeIds) return undefined

      if (getRecord) {
        const activeRecords = activeIds
          ?.map((id) => records[id])
          .filter((record) => record !== undefined)
        if (activeRecords && sortFunc) {
          activeRecords.sort(sortFunc)
        }
        return returnFirst ? activeRecords[0] : activeRecords
      } else {
        return returnFirst ? activeIds[0] : activeIds
      }
    },
  )
}

export const getCallsActiveLookup = (state) => lookupInActives(state, 'calls')

export const getActiveTypingHandles = (state) =>
  lookupInActives(state, 'typing', 'handles')
